import {
  MenuItem,
  Select,
  CircularProgress,
  Grid,
  Typography,
  Autocomplete,
  TextField,
  IconButton,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { getCustomerCode, getVendorDetail } from "../../actions";
import { makeStyles } from "@material-ui/styles";
import { CleanHands } from "@material-ui/icons";
import { dashboardStyle } from "../../Components/InvoiceDetails/style";
const useStyles = makeStyles(dashboardStyle);
function CustomerCode({
  // disabled,
  // formState,
  // changeHandler,
  // user,
  // vendorCodeOnly,
  // index,
  // bordered,
  // setvendorblock,
  // setErrAlertMessage,
  disabled,
  setFormState,
  formState,
  changeHandler,
  bordered,
  user,
  setvendorblock,
  setErrAlertMessage,
  index,
}) {
  const [distributorCode, setDistributorCode] = useState([]);
  const [loading, setLoading] = useState(false);
  const [labelVenodr, setLabelVenodr] = useState("");

  // const autocompleteChangeHandler = (name, value) => {
  //   setFormState((formState) => ({
  //     ...formState,
  //     [name]: value,
  //   }));
  // };

  console.log(distributorCode, "distributorCode in distributorCode")
  const getDistributorData = async () => {
    getCustomerCode(user, setDistributorCode, setLoading);
  };

  useEffect(() => {
    getDistributorData();
  }, [user]);
  const classes = useStyles();
  return (
    <Autocomplete
      sx={{
        "& .MuiInputBase-root": {
          height: "30px",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
        },
        "& .MuiInputBase-input": {
          marginTop: "-5px", // Adjust this value to move the text up
          fontSize: 15
        },
      }}
      id="Vendor"
      options={distributorCode}
      classes={{ option: classes.option }}
      size="small"
      name="Vendor"
      disabled={disabled}
      value={
  distributorCode.find(
    (x) => x?.Customer_Number === formState?.distributor_Code
  ) || null
}
      // value={{
      //   Vendor_Code: formState?.vendor_Code || "",
      //   Vendor_Name:
      //     vendorCode?.find((x) => x?.Vendor_Code === formState?.vendor_Code)
      //       ?.Vendor_Name || "",
      // }}
      // getOptionLabel={(option) =>
      //   (option !== "" &&
      //     `${`${option?.Vendor_Code}`} ${option?.Vendor_Name ? "-" : ""} ${
      //       option?.Vendor_Name
      //     }`) ||
      //   ""
      // }
     getOptionLabel={(option) => {
  if (!option) return "";
  const isBlocked = option?.ALL_COMPANY_CODE === "X";
  let label = option.Customer_Number || "";

  if (option.Customer_Name) {
    label += ` - ${option.Customer_Name}`;
  }

  if (isBlocked) {
    label += " (Blocked)";
  }
  return label.trim();
}}
      loading={loading}
      onChange={(e, newValue) => {
        let objDistr = {
          target: { name: "distributor_Code", value: newValue?.Customer_Number || "" },
        };
        changeHandler(objDistr, index);
        if (newValue?.ALL_COMPANY_CODE === "X" && newValue != null) {
          setvendorblock(true);
          setErrAlertMessage("This Vendor code has been Blocked");
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          name=""
          required
          disabled={disabled}
          value={""}
          sx={{
            input: { color: "black !important" },
          }}

          label={
            labelVenodr === "" &&
              (formState?.distributor_Code == "" || formState?.distributor_Code == null)
              ? "Select a Value"
              : ""
          }
          InputLabelProps={{
            style: {
              fontSize: 15, // Adjust this value to decrease the font size
              marginTop: "-5px", // Adjust this value to move the label up
            }, shrink: false, required: false
          }}
          // placeholder="Select a Value"
          onChange={(event) => {
            getCustomerCode(event.target.value?.trim(), setDistributorCode, setLoading);
            setLabelVenodr(event.target.value);
          }}
          variant={`${bordered ? "outlined" : "standard"}`}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>{params.InputProps.endAdornment}</React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}

export default React.memo(CustomerCode);
